import { Spinner as SpinnerIcon } from "@/components/icons/Spinner";

export const Spinner = () => {
  return (
    <div className="flex justify-evenly w-full">
      <SpinnerIcon className="animate-spin w-4 h-4" />
    </div>
  );
};
